import React from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

import type { MediaItem } from "../../media-widget/types/contexts";
import { usePlaylist } from "../../media-widget/hooks/usePlaylistContext";

const ThumbnailNavigation: React.FC = () => {
  const { mediaItems, currentMediaIndex, setCurrentMediaIndex } = usePlaylist();

  return (
    <div className="flex h-full w-24 flex-col items-center justify-center">
      <div className="flex flex-col items-center gap-2 px-8">
        <button
          className="z-20 mb-2 rounded-full bg-black/20 p-2 text-white hover:bg-black/40"
          onClick={() => setCurrentMediaIndex((prev) => Math.max(0, prev - 1))}
          disabled={currentMediaIndex === 0}
        >
          <ChevronUp size={24} />
        </button>
        <div className="scrollbar-hide flex max-h-[60vh] flex-col gap-2 py-2">
          {mediaItems.map((item: MediaItem, index: number) => (
            <button
              key={item.id}
              onClick={() => setCurrentMediaIndex(index)}
              className={`relative h-16 w-16 overflow-hidden rounded-lg transition-all duration-200 ${
                index === currentMediaIndex
                  ? "scale-110 ring-2 ring-white"
                  : "opacity-70 hover:opacity-100"
              }`}
            >
              <img
                src={item.thumbnail}
                alt={item.title}
                className="h-full w-full object-cover"
              />
            </button>
          ))}
        </div>
        <button
          className="mt-2 rounded-full bg-black/20 p-2 text-white hover:bg-black/40"
          onClick={() =>
            setCurrentMediaIndex((prev) =>
              Math.min(mediaItems.length - 1, prev + 1),
            )
          }
          disabled={currentMediaIndex === mediaItems.length - 1}
        >
          <ChevronDown size={24} />
        </button>
      </div>
    </div>
  );
};

export default ThumbnailNavigation;
